'use strict';

import { getCart, addToCart, updateCart } from './cart-api.js';

document.addEventListener("DOMContentLoaded", function () {
  const giftSettings = JSON.parse(window.giftSettings || "[]");
  const giftSettingsByVariant = JSON.parse(window.giftSettingsByVariant || "[]");
  const customerTags = window.customerTags || [];

  const parseToCents = (amountStr) => Math.round(parseFloat(amountStr) * 100);

  const getSectionsToReload = () => [
    { id: 'cart-drawer', selector: '#CartDrawer' },
    { id: 'cart-icon-bubble' }
  ];

  const reloadSections = (parsedState) => {
    getSectionsToReload().forEach((section) => {
      const sectionHTML = parsedState.sections?.[section.id];
      if (!sectionHTML) return;

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (sectionElement) {
        sectionElement.innerHTML = new DOMParser()
          .parseFromString(sectionHTML, 'text/html')
          .querySelector(section.selector || '.shopify-section').innerHTML;
      }
    });
  };

  const addGift = async (variantId, source) => {
    const props = {
      id: variantId,
      quantity: 1,
      sections: getSectionsToReload().map((section) => section.id),
      sections_url: window.location.pathname
    };

    try {
      const response = await addToCart(props);
      publish(PUB_SUB_EVENTS.cartUpdate, { source });
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const removeGift = async (key, source) => {
    const props = {
      id: key,
      quantity: 0,
      sections: getSectionsToReload().map((section) => section.id),
      sections_url: window.location.pathname
    };

    try {
      const response = await updateCart(props);
      publish(PUB_SUB_EVENTS.cartUpdate, { source });
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const checkCartForGifts = async () => {
    try {
      let cart = await getCart();
      let changesMade = false;

      // --- GWP for Product ---
      for (const gwp of giftSettings) {
        const isTargetInCart = cart.items.some(item => item.product_id === parseInt(gwp.targetProductId));
        const isGiftInCart = cart.items.some(item => item.variant_id === parseInt(gwp.giftProductId));
        const now = new Date();

        let shouldApply = true;
        if (gwp.StartDateGWP?.trim() && now < new Date(gwp.StartDateGWP)) shouldApply = false;
        if (gwp.EndDateGWP?.trim() && now > new Date(gwp.EndDateGWP)) shouldApply = false;
        if (gwp.MinimumAmountGWP?.trim() && cart.total_price < parseToCents(gwp.MinimumAmountGWP)) shouldApply = false;
        if (gwp.NoHasTagGWP?.trim() && customerTags.includes(gwp.NoHasTagGWP)) shouldApply = false;

        if ((!isTargetInCart || !shouldApply) && isGiftInCart) {
          const giftItem = cart.items.find(item => item.variant_id === parseInt(gwp.giftProductId));
          if (giftItem) {
            await removeGift(giftItem.key, 'gift-with-purchase');
            cart = await getCart();
            changesMade = true;
          }
        } else if (isTargetInCart && shouldApply && !isGiftInCart) {
          await addGift(parseInt(gwp.giftProductId), 'gift-with-purchase');
          cart = await getCart();
          changesMade = true;
        }
      }

      // --- GWP for Specific Variant ---
      if (Array.isArray(giftSettingsByVariant) && giftSettingsByVariant.length > 0) {
        const gwpVar = giftSettingsByVariant[0];
        if (gwpVar && gwpVar.SpecificVariantGWP?.trim() && gwpVar.gwpByVariant?.trim()) {
          const giftVariantId = parseInt(gwpVar.gwpByVariant);
          const triggerString = gwpVar.SpecificVariantGWP.toLowerCase().trim();

          let hasTriggerVariant = false;
          hasTriggerVariant = cart.items.some(item =>
            item.variant_options.some(option => option.toLowerCase().includes(triggerString))
          );

          const isGiftInCart = cart.items.some(item => item.variant_id === giftVariantId);
          const now = new Date();

          let shouldApply = true;
          if (gwpVar.StartDateGWPByVariant?.trim() && now < new Date(gwpVar.StartDateGWPByVariant)) shouldApply = false;
          if (gwpVar.EndDateGWPByVariant?.trim() && now > new Date(gwpVar.EndDateGWPByVariant)) shouldApply = false;
          if (gwpVar.NoHasTagGWPByVariant?.trim() && customerTags.includes(gwpVar.NoHasTagGWPByVariant)) shouldApply = false;

          if ((!hasTriggerVariant || !shouldApply) && isGiftInCart) {
            const giftItem = cart.items.find(item => item.variant_id === giftVariantId);
            if (giftItem) {
              await removeGift(giftItem.key, 'gift-with-purchase-byvariant');
              cart = await getCart();
              changesMade = true;
            }
          } else if (hasTriggerVariant && shouldApply && !isGiftInCart) {
            await addGift(giftVariantId, 'gift-with-purchase-byvariant');
            cart = await getCart();
            changesMade = true;
          }
        }
      }

      if (changesMade) {
        reloadSections(cart);
      }
    } catch (error) {
      console.error(error);
    }
  };

  checkCartForGifts();

  if (window.publish && window.subscribe && PUB_SUB_EVENTS?.cartUpdate) {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      if ([
        'gift-with-purchase',
        'gift-with-purchase-byvariant',
        'check-cart-logout'
      ].includes(e.source)) return;

      checkCartForGifts();
    });
  }
});
